"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewFreeModuleSteps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const modal_1 = require("components/cosmos/v2/modal");
const services_1 = require("modules/app/services");
const clickFreeModuleCloseSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleCloseSchema");
const classes_1 = require("modules/content/classes");
const salesManager_1 = require("modules/salesManager");
const activateFreeSignup_1 = __importDefault(require("./activateFreeSignup"));
const configureSalesPage_1 = __importDefault(require("./configureSalesPage"));
const confirmExit_1 = __importDefault(require("./confirmExit"));
const personalizeSalesPage_1 = __importDefault(require("./personalizeSalesPage"));
require("./signUpModal.scss");
var ViewFreeModuleSteps;
(function (ViewFreeModuleSteps) {
    ViewFreeModuleSteps["FREE_MODULE_ACTIVATE"] = "FREE_MODULE_ACTIVATE";
    ViewFreeModuleSteps["SALES_PAGE_CONFIG"] = "SALES_PAGE_CONFIG";
    ViewFreeModuleSteps["SALES_PAGE_CUSTOMIZE"] = "SALES_PAGE_CUSTOMIZE";
    ViewFreeModuleSteps["GIVE_UP"] = "GIVE_UP";
})(ViewFreeModuleSteps || (exports.ViewFreeModuleSteps = ViewFreeModuleSteps = {}));
const SignUpModal = ({ onCloseModal, enableFreeModule }) => {
    const [step, setStep] = (0, react_1.useState)(ViewFreeModuleSteps.FREE_MODULE_ACTIVATE);
    const [lastStep, setLastStep] = (0, react_1.useState)(ViewFreeModuleSteps.FREE_MODULE_ACTIVATE);
    const [mainOffer, setMainOffer] = (0, react_1.useState)();
    const [offers, setOffers] = (0, react_1.useState)([]);
    const [classes, setClasses] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(function getMainOffer() {
        const getMainOffer = async () => {
            const mainOffer = await salesManager_1.SalesService.getMainOffers();
            if (!mainOffer || mainOffer.length === 0) {
                return;
            }
            setMainOffer(mainOffer[0]);
        };
        getMainOffer();
    }, []);
    (0, react_1.useEffect)(function mountOffers() {
        const getOffers = async () => {
            const offers = await salesManager_1.SalesService.getOffers();
            if (!offers || offers.length === 0) {
                return;
            }
            setOffers(salesManager_1.SalesService.formatOffers(offers));
        };
        const getClasses = async () => {
            const classes = await salesManager_1.SalesService.getClasses();
            if (!classes || classes.length === 0) {
                return;
            }
            const formatedClasses = classes_1.ClassesService.formatClasses(classes);
            setClasses(formatedClasses);
        };
        getOffers();
        getClasses();
    }, []);
    const handleExitStep = (step) => {
        setStep(ViewFreeModuleSteps.GIVE_UP);
        setLastStep(step);
    };
    const handleClose = () => {
        if (step === ViewFreeModuleSteps.GIVE_UP) {
            onCloseModal();
            return;
        }
        const schema = new clickFreeModuleCloseSchema_1.ClickFreeModuleCloseSchema({ step });
        services_1.DatahubEventsService.sendEvent({ schema });
        handleExitStep(step);
    };
    const onEnableFreeModule = () => {
        onCloseModal();
        enableFreeModule();
    };
    const renderContentModal = () => {
        const stepComponents = {
            [ViewFreeModuleSteps.FREE_MODULE_ACTIVATE]: ((0, jsx_runtime_1.jsx)(activateFreeSignup_1.default, { onNextStep: () => setStep(ViewFreeModuleSteps.SALES_PAGE_CONFIG), onClose: () => handleExitStep(ViewFreeModuleSteps.FREE_MODULE_ACTIVATE) })),
            [ViewFreeModuleSteps.SALES_PAGE_CONFIG]: ((0, jsx_runtime_1.jsx)(configureSalesPage_1.default, { onEnableFreeModule: onEnableFreeModule, onNextStep: () => setStep(ViewFreeModuleSteps.SALES_PAGE_CUSTOMIZE), mainOffer: mainOffer })),
            [ViewFreeModuleSteps.SALES_PAGE_CUSTOMIZE]: ((0, jsx_runtime_1.jsx)(personalizeSalesPage_1.default, { offers: offers, classes: classes, onPreviousStep: () => setStep(ViewFreeModuleSteps.SALES_PAGE_CONFIG), onEnableFreeModule: onEnableFreeModule })),
            [ViewFreeModuleSteps.GIVE_UP]: ((0, jsx_runtime_1.jsx)(confirmExit_1.default, { onPreviousStep: () => setStep(lastStep), onClose: () => handleClose() }))
        };
        return stepComponents[step];
    };
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, { show: true, onClose: handleClose, blockBackdropClick: true, className: "signup-modal", children: renderContentModal() }));
};
exports.default = SignUpModal;
